// Accessible search overlay controller (vanilla JS)
// Handles open/close, focus, and keyboard interactions reliably on mobile and desktop.
(function() {
  function ready(fn){ if(document.readyState !== 'loading'){ fn(); } else { document.addEventListener('DOMContentLoaded', fn); } }
  ready(function(){
    var overlay = document.getElementById('site-search-overlay');
    if (!overlay) return;
    var form = overlay.querySelector('[data-search-form]') || overlay.querySelector('form');
    var input = form ? form.querySelector('input[type="search"]') : null;
    var submitBtn = form ? form.querySelector('button[type="submit"]') : null;
    var toggles = document.querySelectorAll('[data-search-toggle]');
    var lastFocused = null;

    function setExpanded(val){
      toggles.forEach(function(btn){ btn.setAttribute('aria-expanded', val ? 'true' : 'false'); });
    }

    function focusInput(){
      if (!input) return;
      try {
        input.focus({ preventScroll: true });
        var len = input.value ? input.value.length : 0;
        if (typeof input.setSelectionRange === 'function') {
          input.setSelectionRange(len, len);
        }
      } catch (e) {
        // noop
      }
    }

    function openSearch(){
      if (!overlay) return;
      lastFocused = document.activeElement;
      overlay.classList.remove('hidden');
      // force reflow so opacity transition can run reliably across browsers
      void overlay.offsetWidth;
      overlay.classList.remove('opacity-0', 'pointer-events-none');
      setExpanded(true);
      focusInput();
      document.addEventListener('keydown', onKeydown, true);
      document.addEventListener('focus', trapFocus, true);
    }

    function closeSearch(){
      if (!overlay) return;
      overlay.classList.add('opacity-0', 'pointer-events-none');
      setExpanded(false);
      var onEnd = function(){
        overlay.classList.add('hidden');
        overlay.removeEventListener('transitionend', onEnd);
      };
      overlay.addEventListener('transitionend', onEnd);
      document.removeEventListener('keydown', onKeydown, true);
      document.removeEventListener('focus', trapFocus, true);
      if (lastFocused && typeof lastFocused.focus === 'function') {
        lastFocused.focus();
      }
    }

    function onToggleClick(e){
      e.preventDefault();
      // If overlay is hidden, open; else close
      var isHidden = overlay.classList.contains('hidden') || overlay.classList.contains('opacity-0');
      if (isHidden) openSearch(); else closeSearch();
    }

    function onKeydown(e){
      if (e.key === 'Escape' || e.key === 'Esc') {
        e.stopPropagation();
        e.preventDefault();
        closeSearch();
        return;
      }
      if (e.key === 'Tab') {
        // Minimal focus trap between input and submit button
        var focusables = [];
        if (input) focusables.push(input);
        if (submitBtn) focusables.push(submitBtn);
        if (focusables.length === 0) return;
        var i = focusables.indexOf(document.activeElement);
        if (e.shiftKey) {
          if (document.activeElement === focusables[0]) {
            e.preventDefault();
            focusables[focusables.length - 1].focus();
          }
        } else {
          if (document.activeElement === focusables[focusables.length - 1]) {
            e.preventDefault();
            focusables[0].focus();
          }
        }
      }
    }

    function trapFocus(e){
      if (!overlay || overlay.classList.contains('hidden')) return;
      if (!overlay.contains(e.target)) {
        // redirect focus back into overlay
        e.stopPropagation();
        focusInput();
      }
    }

    // Click outside to close (only when clicking outside the form area)
    overlay.addEventListener('mousedown', function(e){
      if (!form) return;
      if (!form.contains(e.target)) {
        closeSearch();
      }
    });

    toggles.forEach(function(btn){ btn.addEventListener('click', onToggleClick); });
  });
})();

